import {
  Form, Select, TimePicker, DatePicker, Tag,
} from 'antd';
import { useState } from 'react';
import request from '@/api';
import { useEffectOnce } from '@hooks';
import dayjs from 'dayjs';
import isEqual from 'lodash.isequal';
import classes from './index.module.css';
import timezones from '../OrgSettings/timezone';

const { RangePicker } = DatePicker;

// eslint-disable-next-line react/prop-types
export default function OnTimeGDD({ adminDomain, onValuesChange }) {
  const [form] = Form.useForm();
  const [selectedRanges, setSelectedRanges] = useState([]);
  const [quoteConfigData, setQuoteConfigData] = useState({});

  const handleFormChange = (range) => {
    const { time, timeZone } = form.getFieldsValue();
    const body = {
      orderCutOffDailyTime: dayjs(time).format('HH:mm'),
      orderCutOffTimeZone: timeZone,
      orderCutOffDayList: (range).map((item) => ({ startDay: item.startDay, endDay: item.endDay })),
    };
    const isEqualConfig = isEqual(body, quoteConfigData);
    if (!isEqualConfig) {
      onValuesChange(body);
    }
  };
  const handleRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      const newRange = {
        start: dates[0].format('MMM DD'),
        end: dates[1].format('MMM DD'),
        startDay: dates[0].format('YYYY-MM-DD'),
        endDay: dates[1].format('YYYY-MM-DD'),
      };
      const index = selectedRanges.findIndex((range) => range.start === newRange.start && range.end === newRange.end);
      if (index === -1) {
        setSelectedRanges([...selectedRanges, newRange]);
        handleFormChange([...selectedRanges, newRange]);
      }
      form.setFieldValue('daysOff', []);
    }
  };
  const getData = async () => {
    try {
      const { code, data: { quoteConfig = {} } = {} } = await request('query-merchant-gdd-configs', {
        method: 'POST',
        body: {
          adminDomain,
        },
      });
      if (code === 0) {
        const { orderCutOffDayList = [], orderCutOffTimeZone = 'America/New_York', orderCutOffDailyTime } = quoteConfig;
        form.setFieldsValue({
          timeZone: orderCutOffTimeZone,
          time: orderCutOffDailyTime ? dayjs(orderCutOffDailyTime, 'HH:mm') : null,
        });
        setQuoteConfigData(quoteConfig);
        setSelectedRanges(orderCutOffDayList.map((item) => ({ ...item, start: dayjs(item.startDay).format('MMM DD'), end: dayjs(item.endDay).format('MMM DD') })));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffectOnce(async () => {
    await getData();
  }, []);

  const handleClose = (range) => {
    const newSelectedRanges = selectedRanges.filter((item) => item.start !== range.start && item.end !== range.end);
    setSelectedRanges(newSelectedRanges);
    form.setFieldValue('daysOff', []);
  };
  // 如果没有申请过on-time GDD，则不显示on-time GDD settings
  if (!Object.keys(quoteConfigData)?.length) return null;
  return (
    <div className={classes.on_time_settings}>
      <Form
        name="enable_bp"
        layout="vertical"
        form={form}
        onValuesChange={() => handleFormChange(selectedRanges)}

      >
        <div className={classes.settings_title}>
          On-time Delivery Guarantee is
          <span className={classes.enabled}> enabled</span>
        </div>
        <div className={classes.panel}>
          <div className={classes.setting}>
            <div className={classes.setting_title}>
              ORDER CUT-OFF TIME
            </div>
            <div className={classes.setting_desc}>
              <Form.Item label="Time zone" name="timeZone">
                <Select options={timezones} style={{ width: '500px' }} />
              </Form.Item>
              <Form.Item label="Time" name="time" noStyle>
                <TimePicker format="h:mm A" hourStep={1} minuteStep={60} needConfirm showNow={false} style={{ width: '500px' }} use12Hours />
              </Form.Item>
            </div>
          </div>
          <div className={classes.setting}>
            <div className={classes.setting_title}>
              ANY EXPECTED ORDER PROCESSING DELAY IN THE NEAR FUTURE?
            </div>
            <div className={classes.setting_desc}>
              <Form.Item
                label="Days off"
              >
                <Form.Item noStyle name="daysOff">
                  <RangePicker
                    onChange={handleRangeChange}
                    allowClear
                    placeholder={['Select', '']}
                    format="MMM DD"
                    style={{ width: '500px' }}
                  />
                </Form.Item>

                <div className={classes.tag}>
                  {selectedRanges.map((range, index) => (
                    <Tag
                      // eslint-disable-next-line react/no-array-index-key
                      key={Date.now() + index}
                      closable
                      onClose={() => handleClose(range)}
                    >
                      {range.start}
                      {' '}
                      -
                      {range.end}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>

    </div>
  );
}
